import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ConditionGroupListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ConditionGroupListPage extends Component<ConditionGroupListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.condition_group.list }}
                pages={{
                    entity: InferenceEntities.condition_group(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}